import React from 'react'

import { Image } from '@/components/Shared/Image'

interface Props {
  venueLogo: any
}

export const VenueLogo = ({ venueLogo }: Props) => {
  if (!venueLogo) {
    return null
  }

  return (
    <div className="absolute bottom-0 flex w-full justify-start px-3 pb-9">
      <div className="relative flex h-[58px] w-[80px] justify-center overflow-hidden rounded-xl bg-surface-ui-background shadow-xl">
        <Image
          image={venueLogo}
          className="!object-contain"
          objectFit="contain"
          layout="fill"
        />
      </div>
    </div>
  )
}
